import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ContentCard from '@/components/feature/ContentCard';
import SchemaOrg from '@/components/base/SchemaOrg';
import { CATEGORY_ALL, CATEGORY_CONTENT } from '@/mocks';

const categoryNames: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
  jilupian: '纪录片',
  jingsong: '惊悚片',
};

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const activeSlug = slug || 'dianying';
  const activeName = categoryNames[activeSlug] || '电影';
  const contentList = CATEGORY_CONTENT[activeSlug] || [];

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;
  const totalPages = Math.ceil(contentList.length / pageSize);
  const paginatedContent = contentList.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setCurrentPage(1);
  }, [activeSlug]);

  return (
    <>
      <SchemaOrg type="WebPage" data={{
        name: `777影院 - ${activeName}分类`,
        description: `777影院午夜伦不卡${activeName}频道，提供最新${activeName}在线观看，高清画质，流畅不卡。`,
        url: `https://777cinema.com/category/${activeSlug}`,
      }} />

      <div className="min-h-screen bg-background-950">
        <Navbar />
        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: activeName },
            ]}
          />

          <section className="px-4 md:px-6 pt-4 pb-6">
            <div className="max-w-[1440px] mx-auto">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100 mb-6">
                {activeName}
                <span className="text-base font-normal text-foreground-500 ml-3">
                  共 {contentList.length} 部作品
                </span>
              </h1>

              <div className="flex flex-wrap gap-2 mb-8">
                {CATEGORY_ALL.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                      activeSlug === cat.slug
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-800 text-foreground-400 hover:text-foreground-200 hover:bg-background-700'
                    }`}
                  >
                    <span className="flex items-center gap-1.5">
                      <i className={`${cat.icon} text-xs`}></i>
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>

              {paginatedContent.length > 0 ? (
                <>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
                    {paginatedContent.map((item) => (
                      <ContentCard key={item.id} item={item} />
                    ))}
                  </div>

                  {totalPages > 1 && (
                    <div className="flex items-center justify-center gap-2 mt-10">
                      <button
                        onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                        disabled={currentPage === 1}
                        className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-foreground-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                      >
                        <i className="ri-arrow-left-s-line"></i>
                      </button>
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-medium transition-colors ${
                            currentPage === page
                              ? 'bg-primary-500 text-background-50'
                              : 'bg-background-800 text-foreground-400 hover:text-foreground-200'
                          }`}
                        >
                          {page}
                        </button>
                      ))}
                      <button
                        onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                        disabled={currentPage === totalPages}
                        className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:text-foreground-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                      >
                        <i className="ri-arrow-right-s-line"></i>
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                    <i className="ri-film-line text-4xl text-foreground-600"></i>
                  </div>
                  <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
                </div>
              )}
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}